// External Imports

// Internal Imports

/** ========================================================================
 * * NoRecordsFound Component
 * This component renders a line stating no records found.
 * ========================================================================== */

export default function NoRecordsFound() {
  /* ======================  ====================== */
  return (
    <div className="flex items-center w-full mx-auto space-x-4 text-sm lg:w-1/2">
      <hr className="w-1/2 lg:w-full hr" />
      <p className="w-full text-center text-stone-400 whitespace-nowrap">No Records Found</p>
      <hr className="w-1/2 lg:w-full hr" />
    </div>
  );
}
